import React from 'react';
import styled from 'styled-components';
import ContactForm from './ContactForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { AnimatedSection } from '../common/AnimatedSection';

const ContactContainer = styled.section`
  padding: var(--spacing-xl) 0;
  background-color: #f8f8f8;
  background-image: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), 
                    url('https://images.unsplash.com/photo-1501618669935-18b6ecb13d6d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2064&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const ContactContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-sm);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-lg);
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div`
  @media (max-width: 992px) {
    order: 2;
  }
`;

const ContactHeading = styled.h2`
  margin-bottom: var(--spacing-md);
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: var(--accent);
  }
`;

const ContactSubheading = styled.p`
  font-size: 1.1rem;
  margin-bottom: var(--spacing-md);
  max-width: 450px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-md);
`;

const InfoIcon = styled.div`
  width: 50px;
  height: 50px;
  background-color: var(--primary-color);
  color: var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-sm);
  font-size: 1.25rem;
`;

const InfoContent = styled.div``;

const InfoTitle = styled.h4`
  margin-bottom: 5px;
`;

const InfoText = styled.p`
  color: #666;
`;

const ContactLink = styled.a`
  color: inherit;
  transition: color var(--transition-fast);
  
  &:hover {
    color: var(--accent);
  }
`;

const ContactFormContainer = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: var(--border-radius-lg);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  
  @media (max-width: 992px) {
    order: 1;
  }
`;

const FormHeading = styled.h3`
  margin-bottom: var(--spacing-md);
  text-align: center;
`;

const ContactSection: React.FC = () => {
  return (
    <ContactContainer id="contact">
      <ContactContent>
        <ContactInfo>
          <AnimatedSection>
            <ContactHeading>Contactez-Nous</ContactHeading>
            <ContactSubheading>
            N'hésitez pas à nous contacter pour toute demande de devis, réservation ou information complémentaire.
          </ContactSubheading>
          </AnimatedSection>
          
          <InfoItem>
            <InfoIcon>
              <FontAwesomeIcon icon={faPhone} />
            </InfoIcon>
            <InfoContent>
              <InfoTitle>Téléphone</InfoTitle>
              <InfoText>
                <ContactLink href="tel:+33695808096">+33 6 95 80 80 96</ContactLink>
              </InfoText>
            </InfoContent>
          </InfoItem>
          
          <InfoItem>
            <InfoIcon>
              <FontAwesomeIcon icon={faEnvelope} />
            </InfoIcon>
            <InfoContent>
              <InfoTitle>Email</InfoTitle>
              <InfoText>
                <ContactLink href="mailto:contact@vtcprivetoure.fr">
                  contact@vtcprivetoure.fr
                </ContactLink>
              </InfoText>
            </InfoContent>
          </InfoItem>
          
          <InfoItem>
            <InfoIcon>
              <FontAwesomeIcon icon={faClock} />
            </InfoIcon>
            <InfoContent>
              <InfoTitle>Disponibilité</InfoTitle>
              <InfoText>
                Service 24/7 pour réservations anticipées
              </InfoText>
            </InfoContent>
          </InfoItem>
        </ContactInfo>
        
        <ContactFormContainer>
          <FormHeading>Réserver Votre Trajet</FormHeading>
          <ContactForm />
        </ContactFormContainer>
      </ContactContent>
    </ContactContainer>
  );
};

export default ContactSection; 